import {getDataWithPromise, Globals} from "root/globals";
import {handleAjaxError} from "root/DataFunctions/ErrorHandlingFunctions";


export const getAppUsageCountsForLea = (lea_id, user_type, onComplete) =>
{
    const url = Globals.APIFolder + '/eyfs/app/usage/lea/' + lea_id + '/' + user_type ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}
